import { trackEvent } from "@src/utils/trackEvent"
import { useEffect, useRef } from "react"

const PATHNAME_VIEW_EVENTS: Readonly<Record<string, string>> = {
  "/contacts": "contacts_viewed",
  "/history": "history_viewed",
}

export function usePathnameViewTracking(pathname: string) {
  const previousPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    if (previousPathnameRef.current === pathname) return
    previousPathnameRef.current = pathname

    const eventName = PATHNAME_VIEW_EVENTS[pathname]
    if (eventName != null) trackEvent(eventName)
  }, [pathname])
}
